import vars from '../../vars';

$(document).ready(function() {
    vars.$noticeClose.on('click', (e) => {
        vars.$notice.addClass('hide');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/notice/notice.js